import React from "react";
import { Calendar, MapPin } from "lucide-react";
import { getDaysUntil } from "./eventContent";

function countdownLabel(startDate) {
  const days = getDaysUntil(startDate);
  if (days === null || days < 0) return null;
  if (days === 0) return "Today";
  if (days === 1) return "Tomorrow";
  return `${days} days to go`;
}

const EventHero = ({ event, tagline, heroImage }) => {
  const countdown = countdownLabel(event?.start_date);

  return (
    <div
      className={`vw-hero${heroImage ? "" : " vw-hero--fallback"}`}
      style={heroImage ? { backgroundImage: `url(${heroImage})` } : undefined}
    >
      <div className="vw-hero-overlay" />
      <div className="vw-hero-content">
        {countdown && <span className="vw-hero-countdown">{countdown}</span>}
        <h1 className="vw-hero-title">{event?.name}</h1>
        {tagline && <p className="vw-hero-tagline">{tagline}</p>}
        <div className="vw-hero-meta">
          {event?.start_date && (
            <span>
              <Calendar size={14} aria-hidden="true" />
              {new Date(event.start_date).toLocaleDateString(undefined, {
                month: "long",
                day: "numeric",
                year: "numeric",
              })}
            </span>
          )}
          {event?.location && (
            <span>
              <MapPin size={14} aria-hidden="true" />
              {event.location}
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

export default EventHero;